//'@fortawesome/free-regular-svg-icons'
//'@fortawesome/free-brands-svg-icons'
import { LinkContent, UnityData } from "./LinkDataInterface";
import { TableLink } from "./TableLink";
import { Header } from "./Header";
import styled from "styled-components";
import { useMemo } from "react";
import useWindowDimensions from "./windowDimensions";

function Main({ content }: { content: UnityData }) {
  const data = useMemo(() => initializeButtons(content), [content]);

  const dimensions = useWindowDimensions();

  return (
    <PageStyle
      id="root"
      $img={
        dimensions.height < dimensions.width
          ? data.style.background.imgLandscape
          : data.style.background.imgPortrait
      }
      $color={data.style.background.color}
    >
      <Header hContent={data.header} />
      <TableLink groups={data.groups} />
    </PageStyle>
  );
}

function setDefaultButton(
  link: LinkContent,
  bDefault: {
    color: string;
    text: string;
    hover: string;
    textHover: string;
  }
) {
  if (!link.color) link.color = bDefault.color;
  if (!link.text) link.text = bDefault.text;
  if (!link.hover) link.hover = bDefault.hover;
  if (!link.textHover) link.textHover = bDefault.textHover;
  return link;
}

function initializeButtons(data: UnityData): UnityData {
  data.groups.forEach((group) => {
    group.forEach((link) => {
      link = setDefaultButton(link, data.style.button);
    });
  });
  data.header.quickLinks.forEach((link) => {
    link = setDefaultButton(link, data.style.button);
  });

  return data;
}

const PageStyle = styled.div<{ $img: string; $color: string }>`
  margin: 0;
  height: 100%;
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-image: url(${(props) => props.$img});
  background-color: ${(props) => props.$color};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
`;
//minmax(75px 30%) 1fr;
export default Main;
